import styled from 'styled-components';
import Base from './base';

const WhiteButton = styled(Base)`
  background-color: ${props => props.theme.carvana.white};
  border-color: ${props => props.theme.carvana.blue};
  border-radius: 2rem;
  color: ${props => props.theme.carvana.blue};
  font-size: 0.7rem;
  font-weight: bold;
  padding: 0.5rem 1rem;
  min-height: inherit;
  min-width: 6rem;
  width: auto;

  &:focus {
    outline: none;
  }
`;

export default WhiteButton;
